import _ from 'underscore';
import { Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import CutangleItem from '../item/cutangleItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class CutangleLeftField
 */
export default class CutangleLeftField extends LengthUnitField {
    type = 'cutangleLeft';
    supports = 'supportsPositioning';
    handle = null;

    /**
     * Do nothing in this case
     */
    updateValue() {}

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const value = this.getValue();
        const isStartPoint = this.handle.active.point === 'startPoint';

        const newPoint = isStartPoint
            ? new Point(value, item.get('line').startPoint.y)
            : new Point(value, item.get('line').endPoint.y);

        this.handle.projectPoint(this.handle.active.point, newPoint);
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const value = this.getValue();
        const isStartPoint = this.handle.active.point === 'startPoint';

        const newPoint = isStartPoint
            ? new Point(value + difference, item.get('line').startPoint.y)
            : new Point(value + difference, item.get('line').endPoint.y);

        this.handle.projectPoint(this.handle.active.point, newPoint);
    }

    /**
     * Do action.
     *
     * @param {CutangleItem} item
     */
    action(item) {
        this.hide();

        if (!item) return;

        const debouncedChangeVisibility = _.debounce((show) => {
            if (show) this.show();
            else this.hide();
        }, 250);

        item.on('activatePoint', (point, angle, handle) => {
            const isOnHorizontalBorder = point.y === 0 || point.y === item.getParentItem().get('height');

            if (isOnHorizontalBorder) {
                debouncedChangeVisibility(true);
                this.handle = handle;
                this.input.val(point.x);
            } else {
                debouncedChangeVisibility(false);
            }
        });

        item.on('deactivatePoint', () => debouncedChangeVisibility(false));
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item instanceof CutangleItem;
    }
}
